import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="bg-ink min-h-screen pt-[110px] md:pt-[130px] pb-28 flex items-center" data-testid="payment-cancel">
      <div className="container-x max-w-xl mx-auto text-center">
        <XCircle className="w-14 h-14 text-white/40 mx-auto" />
        <h1 className="font-heading text-4xl md:text-5xl uppercase mt-8">Zahlung abgebrochen</h1>
        <p className="text-white/60 mt-4">Kein Problem – dein Warenkorb ist gespeichert. Du kannst jederzeit fortfahren.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/shop" className="btn-primary"><ArrowLeft className="w-4 h-4" /> Zurück zum Shop</Link>
          <Link to="/product" className="btn-ghost">Produkt ansehen</Link>
        </div>
      </div>
    </div>
  );
}
